module.exports = __webpack_public_path__ + "img/SKMJ_heavy4.be60b571.jpg";